//////////////////
// IMPORTS
//////////////////
import * as React from "react";
import { colors } from "@clockwise/web-commons/src/styles/color.styles";
import { CWIDProps } from "@clockwise/web-commons/src/util/cw-id.util";

//////////////////
// STYLES
//////////////////
export const baseStyles: React.CSSProperties = {
  color: colors.green.darker,
  borderColor: colors.green.darker,
  borderStyle: "dashed",
  borderBottomWidth: 1,
  textDecoration: "none",
  transition: "color .3s, border .3s",
  cursor: "pointer",
};

export const hoverStyles = {
  color: colors.green.standard,
  borderColor: colors.green.standard,
  borderStyle: "solid",
};

export const baseStylesLight: React.CSSProperties = {
  ...baseStyles,
  color: "white",
  borderColor: "white",
};

//////////////////
// TYPES
//////////////////
interface IProps {
  href?: string;
  toggleable?: boolean;
  target?: string;
  onClick?: (e?: React.SyntheticEvent<any>) => void;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  light?: boolean;
}

interface IState {
  toggled: boolean;
  hovered: boolean;
}

//////////////////
// COMPONENT
//////////////////
export class A extends React.PureComponent<IProps & CWIDProps, IState> {
  constructor(
    props: IProps &
      CWIDProps &
      React.DetailedHTMLProps<React.HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
  ) {
    super(props);

    this.state = {
      toggled: false,
      hovered: false,
    };

    this.onClick = this.onClick.bind(this);
  }

  private onHover = (hovered: boolean) => {
    this.setState({ hovered });
  };

  private onClick(event: React.FormEvent<HTMLAnchorElement>) {
    if (this.props.toggleable) {
      event.preventDefault(); // note: links + toggle won't work
      this.setState({ toggled: !this.state.toggled });
    }

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  private maybeRenderToggle = () => {
    if (!this.props.toggleable) {
      return "";
    }
    return this.state.toggled ? " -" : " +";
  };

  public render() {
    const hoverStateStyle = this.state.hovered ? hoverStyles : {};
    const defaultStyles = this.props.light ? baseStylesLight : baseStyles;
    const styles = {
      ...defaultStyles,
      ...hoverStateStyle,
      ...this.props.style,
    };

    return (
      <a
        style={styles}
        href={this.props.href}
        onClick={this.onClick}
        target={this.props.target}
        onMouseEnter={() => this.onHover(true)}
        onMouseLeave={() => this.onHover(false)}
        cw-id={this.props["cw-id"]}
      >
        {this.props.children}
        {this.maybeRenderToggle()}
      </a>
    );
  }
}
